export default "__VITE_ASSET__DBqsyWDT__ 480w, __VITE_ASSET__DjjQpLlL__ 768w, __VITE_ASSET__BIXltffQ__ 1200w, __VITE_ASSET__B7jsjCCo__ 1600w";